import { MarketingHeader } from "./MarketingHeader";
import { useMobileMenu } from "@platform/store";

export type Props = {
  // navigation items component
  children: React.ReactNode;
};

export function MarketingHeaderContainer({ children }: Props) {
  const { isOpen: isMobileMenuOpen, open: openMobileMenu, close: closeMobileMenu } = useMobileMenu();

  return (
    <MarketingHeader
      isMobileMenuOpen={isMobileMenuOpen ?? false}
      openMobileMenu={openMobileMenu}
      closeMobileMenu={closeMobileMenu}
    >
      {children}
    </MarketingHeader>
  );
}

export default MarketingHeaderContainer;

